export const colors = {
    primary: '#009D3C',
    secondary: '#747474',
    accent: '#014c4a',
    error: '#f24f4f',
    info: '#2196F3',
    success: '#49BF77',
    warning: '#FECF32',
    lines: '#EAF0F5',
};
